const locale = {
  consent: {
    title: () => "Prywatność",
    description: () =>
      `Akceptuję <a href="/rs-policy-privacy.pdf" target="_blank">Politykę Prywatności</a>. Zgadzam się na wykorzystanie cookies w celu analizy ruchu strony.`,
    accept: () => "Zgoda",
    close: () => "Zamknij",
  },
  navbar: {
    pricing: () => "Cennik",
    hardware: () => "Sprzęt",
    contact: () => "Kontakt z nami",
    menu: {
      possibilities: () => "Możliwości",
      cloud: () => "Rapidshop Cloud",
      kiosks: () => "Kioski samoobsługowe",
      pos: () => "Aplikacja POS",
      kds: () => "Rapid KDS",
      discounts: () => "Promocje i rabaty",
      management: () => "Zarządzanie sprzętem",
      rapidshopAI: () => "Rapidshop AI",
      descriptions: {
        cloud: () =>
          "Twoje transakcje, przychody, zamówienia widoczne w czasie rzeczywistym w naszej Chmurze. Dostępna z każdego urządzenia",
        kiosks: () =>
          "Zwiększaj sprzedaż nawet o 30%, redukuj koszty, przyciągaj Klientów",
        pos: () =>
          "Ergonomiczna aplikacja dla Twoich kelnerów, sprzedawców. Interaktywny ekran Klienta: e-Paragon, vouchery zawsze na Twojej ladzie.",
        kds: () =>
          "Prosty w obsłudze ekran kuchenny, złączony z Twoimi drukarkami, który usprawni wydawanie zamówień oraz komunikację w kuchni",
        discounts: () => "Generuj kupony, przypisuj wirtualne pieczątki",
        management: () => "Zarządzaj sprzętem zdalnie i lokalnie",
        rapidshopAI: () =>
          "Zarządzanie Twoim sklepem, restauracją, kawiarnią z wykorzystaniem sztucznej inteligencji. Wirtualny asystent Klienta w Kiosku",
      },
    },
  },
  landingPage: {
    firstSlide: {
      title: () => "Powitaj Rapidshop AI",
      subtitle: () => "AI w końcu w Twoim punkcie sprzedaży!",
      description: () =>
        "To nie jest zwykła zmiana. To rewolucja w obsłudze Twoich Klientów i Twojego biznesu.",
      description2: () =>
        "Nasze kioski rozmawiają z Klientem jak prawdziwy człowiek. Dzięki mocy najnowszych modeli językowych AI, nasze kioski są w stanie zrozumieć i odpowiedzieć na pytania Klientów, a także zaproponować im produkty, które ich zainteresują.",
    },
    hero: {
      autotype: {
        text1: () => "Zwiększ swoją sprzedaż",
        text2: () => "Ułatwiaj sobie pracę",
        text3: () => "Więcej czasu dla Ciebie",
        text4: () => "Twój nowy POS!",
      },
      subtitle: () =>
        "To więcej niż POS. To cyfrowa transformacja w Twoim gastro.",
    },
    offer: {
      title: () => "Stworzyliśmy od podstaw",
      subtitle: () => "nowy ekosystem dla Twojej restauracji i detalu",
      subtitle2: () =>
        "dzięki któremu zyskasz dodatkowe przychody, nowych Klientów,",
      subtitle3: () =>
        "a nowo pozyskanych Klientów zachęcisz do częstych powrotów!",

      profit1: {
        title: () => "Przejrzysty panel zarządzania",
        description: () =>
          "Zarządzaj swoim lokalem zdalnie. Zobacz przychody, zamówienia, stany magazynowe w czasie rzeczywistym.",
      },
      profit2: {
        title: () => "Nowoczesny, korzystny cenowo sprzęt",
        description: () =>
          "Sprzęt, który zadba o Twoich Klientów i Twój biznes. Oferuj promocje, sprzedawaj tam, gdzie jeszcze tego nie robiłeś.",
      },
      profit3: {
        title: () => "Program POS",
        description: () =>
          "Niezależny i działający w pełnej harmonii między lokalem i Twoją Chmurą Rapidshop. Nie przestaje działać, kiedy masz problemy z zasięgiem Internetu.",
      },
      profit4: {
        title: () => "Sztuczna inteligencja",
        description: () =>
          "Wprowadź jej supermoce do Twojego lokalu! Pozwól sztucznej inteligencji zadbać o Twoich gości, a Tobie - zarządzać lokalem.",
      },
    },
    solution: {
      handheld: {
        title: () => "Terminale ręczne i nablatowe Rapidshop",
        badge1: () => "Wsparcie dla personelu",
        badge2: () => "Usprawnienie obsługi",
        description1: () =>
          "Eleganckie, szybkie i intuicyjne terminale Rapidshop to ergonomia, wydajność i niezawodność w jednym. Pisząc oprogramowanie na nasze terminale, przyjęliśmy zasadę, że nie tworzymy absurdalnych procedur. Zamiast wielu dziwnych i przeróżnych klawiszy, nasze terminale same prowadzą Twoją załogę, odciążając Cię od konieczności ciągłego szkolenia nowych pracowników.",
        description2: () =>
          "W skrócie, te rewolucyjne - a za razem przystępne cenowo urządzenia przyspieszają zamówienia i płatności. Twoja załoga sprawnie obsługuje sale, zawsze wie, co polecić Klientowi, a to wszystko w efekcie prowadzi do wyraźnego wzrostu obrotów.",
        description3: () =>
          "Ponadto nasze terminale współpracują w jednym systemie z naszymi kioskami, co powoduje, że możesz tak samo łatwo zarządzać zamówieniami z kiosku, jak i z terminala. Wszystko to po to, by Twoi klienci byli zadowoleni, a Ty mógł skupić się na rozwijaniu swojego biznesu.",
        cta: () => "Dowiedz się więcej",
      },
      kiosk: {
        title: () => "Kioski samoobsługowe z opcją agenta AI",
        badge1: () => "Ze sztuczną inteligencją",
        badge2: () => "Dla wzrostu obrotów",
        description1: () =>
          `Pomyśl o tym, <b>ile mógłbyś więcej mieć Klientów</b>, jeśli
            zapewniłbyś im możliwość zakupu Twoich produktów w chwilach, w
            których się nad tym zastanawiają.`,
        description2: () =>
          `Pomyśl o tym, <b>o ile więcej osób zrobi u Ciebie większe zamówienie</b>
            dzięki rekomendacjom i rabatom dostępnych w naszym kiosku przez cały
            czas działania Twojego lokalu. <b>Ile klentów wróci do Kiosku z dopracowanym UI.</b>`,
        description3: () =>
          `Zlikwiduj bariery językowe - nasz Kiosk obsługuje wiele języków,
            potrafi także mówić w języku Twojego Klienta. <b>Nie musisz się
            martwić o to, że Klient nie rozumie Twojego menu.</b>`,
        description4: () =>
          `Kiosk możesz umieścić na stojaku podłogowym lub dyskretnie
            wkomponować na blacie w Twoim lokalu. Klienci cenią nasze kioski za
            komfort, który pozwala im w spokoju zapoznać się z ofertą. Dzięki
            inteligentnym funkcjom sprzedaży i intrygującym propozycjom
            widocznym na ekranie, zachęcają do częstszego wyboru i zakupu
            większej ilości pozycji z menu.`,
        cta: () => "Dowiedz się więcej",
      },
      cloud: {
        title: () => "Rapidshop Cloud",
        badge1: () => "Sprzedaż LIVE w jednym panelu",
        badge2: () => "Sprytny kreator menu",
        badge3: () => "Zarządzanie urządzeniami",
        badge4: () => "Raporty",
        description1: () =>
          `W Twoim nowym panelu Rapidshop Cloud znajdziesz wszystko, co
            potrzebujesz, aby zarządzać swoim biznesem. Sprawdzisz sprzedaż na
            żywo, zobaczysz, co zamawiają Twoi klienci, a także jakie dania
            cieszą się największym zainteresowaniem. Wszystko to w jednym
            miejscu, z dowolnego urządzenia, w dowolnym miejscu.
            Z kanałów online i offline - raporty z Kiosku, Kas, Stolików, a
            także z dostaw - wszystko w jednym miejscu.`,
        description2: () =>
          `Twórz swoje menu niczym artysta w naszym przełomowym edytorze menu.
            Nie tylko dodawaj dania, ale organizuj je w foldery, przeplataj
            reklamami Twoich promocji, a nawet filmami wideo.`,
        description3: () =>
          `Zarządzaj swoimi urządzeniami z poziomu panelu. Zdalnie restartuj
            kioski, aktualizuj menu, a nawet zablokuj wybrane dania.
            Steruj drukarkami i monitorami`,
        cta: () => "Dowiedz się więcej",
      },
      otherElements: {
        title: () =>
          "Lokalizatory, pagery, ekrany na kuchnię (KDS), aplikacje mobilne...",
        title2: () => `Rapidshop oferuje więcej niż się spodziewasz`,
        title3: () => "i to w jednym miejscu.",
        description: () =>
          `Chcemy, abyś miał w naszym systemie wszystko, czego potrzebujesz
            do prowadzenia Twojej restauracji. Dlatego w naszej ofercie
            znajdziesz nie tylko urządzenia POS z programem AI, ale także
            lokalizatory, pagery, ekrany na kuchnię (KDS), aplikacje mobilne,
            sklepy internetowe i wiele innych rozwiązań.`,
        description2: () => "Już niedługo jeszcze więcej nowości.",
        description3: () =>
          `Sprawdź ofertę naszych subskrypcji, aby dowiedzieć się o naszych
            innowacyjnych rozwiązaniach dla detailu i gastronomii.`,
        caseStudy: () => "Jak to wygląda w praktyce?",
        seeOurSolutionLive: () =>
          "Zobacz, jak Rapidshop pomaga usprawnić sprzedaż w warszawskiej sieci Fenicja.",
      },
    },
    contactEndorsement: {
      title: () => "Zacznij zwiększać swoje obroty już dziś z nami!",
      title2: () => "Porozmawiajmy!",
      description: () =>
        `Pozostaw nam swoje dane kontaktowe. Twój dedykowany doradca
            zaproponuje termin na krótkie spotkanie online, na którym pokażemy Ci możliwości naszego systemu i 
            <b>odpowiemy na wszystkie Twoje pytania.</b>.`,
      description2: () =>
        `Wolisz spotkać się z nami na
            żywo? Nasze biuro znajduje się dwa kroki
            od warszawskiego Dworca Centralnego. Umówimy spotkanie, na którym
            będziesz mógł własnoręcznie przetestować system Rapidshop.`,
      description3: () =>
        `Wolisz wysłać maila? Napisz do nas: <a href="mailto:kontakt@rapidshop.pl">kontakt@rapidshop.pl</a>.`,
    },
    trust: {
      title: () => "Technologia, która rośnie razem z Tobą",
      description1: () =>
        "Nasz system powstał na fundamencie najnowszych technologii, kształtowanych przez realne doświadczenie w branży restauracyjnej. Efekt? Stabilne, ergonomiczne rozwiązania, które działają intuicyjnie od pierwszego dnia.",
      description2: () =>
        "Napędza nas nieustanne dążenie do innowacji i jakości — po to, by nasi klienci zawsze mieli narzędzia, których naprawdę potrzebują do rozwijania swojego biznesu.",
      eventInfo: () => "Gastro Quick Service, Ptak Warsaw Expo, 2025",
      trustedBy: () => "Zaufali nam:",
      badges: {
        innovation: () => "Innowacyjność",
        quality: () => "Jakość",
        experience: () => "Doświadczenie",
      },
    },
    cards: {
      header: () => "Rapidshop to technologia która pozwoli Ci wykorzystać",
      title: () => "pełny potencjał Twojego biznesu",
      whatYouGain: () => "CO ZYSKUJESZ?",
      cards: {
        card1: {
          title: () => "Chmura + POS",
          youSave1: () => "3 dni w tygodniu",
          youSave2: () => "3 godziny dziennie",
          youSave3: () => "3 osoby w zespole",
          description: () =>
            "Zarządzaj swoją firmą z chmury. Ustawiaj ceny, promocje, sprawdzaj raporty i zarządzaj personelem i sprzętem z dowolnego miejsca na świecie.",
        },
        card2: {
          title: () => "Obsługa systemu kaucyjnego i KSeF",
          youSave1: () => "zgodność z przepisami",
          youSave2: () => "czas",
          description: () =>
            "Wprowadź POS idealny dla obecnych czasów: zgodny z KSeF i systemem kaucyjnym. Nabijaj kaucje i opakowania automatycznie razem z produktami.",
        },
        card3: {
          title: () => "Urządzenia 3 in 1 - POS, terminal, kasa",
          youSave1: () => "4 dni w miesiącu",
          youSave2: () => "brak kosztownych serwisów",
          youSave3: () => "pracowników",
          description: () =>
            "Buduj swoją restaurację na nowoczesnym i oszczędnym sprzęcie 3 in 1, które oprócz funkcji sprzedaży oferuje funkcje terminala płatniczego i kasy fiskalnej w jednym urządzeniu. \n\nU nas 3 in 1 jest nie tylko na małym urządzeniu sprzedażowym do ręki - możesz mieć również Kiosk i Sprzęt POS który oferuje tę samo bogactwo usług.",
        },
        card4: {
          title: () => "Kioski samoobsługowe",
          youSave1: () => "czas obsługi klienta",
          youSave2: () => "większy koszyk",
          description: () =>
            "Zwiększ efektywność swojego biznesu dzięki naszym kioskom samoobsługowym. Pozwalają na więcej, niż się spodziewasz: świetnie obsługują Twoje promocje automatycznie, polecają produkty oraz obsługują kaucję.",
        },
        card5: {
          title: () => "Skryptowy silnik promocji",
          youSave1: () => "większy koszyk",
          youSave2: () => "atrakcyjne promocje",
          youSave3: () => "powracający klienci - fani Twojej restauracji",
          description: () =>
            "Innowacyjny silnik promocji _Rapidshop Boosters_, do którego możesz dodać własny skrypt to odpowiedź na oczekiwania Klientów w erze nowoczesnej sprzedaży.\nDzięki silnikom, które uruchamiamy wprost na Twoim urządzeniu POS, możesz w pełni kontrolować koszyk i dokonywać na nim zmian w zależności od sytuacji sprzedażowej.\nMasz teraz narzędzie, aby tworzyć promocje które będą idealnie dopasowane do Twojej oferty - na poziomie światowych marek quick service.",
        },
        card6: {
          title: () => "Polecanie produktów",
          youSave1: () => "większy koszyk",
          youSave2: () =>
            "zadowoleni klienci, którzy polecają Twój lokal innym",
          description: () =>
            "Zacznij sprzedawać więcej i mądrzej dzięki wszechstronnemu poleecaniu produktów.\nPolecaj najbardziej trafne dodatki do artykułu, polecaj także przy zakończeniu rachunku.\nMobilizuj swoją załogę do skutecznego promowania dodatków do koszyka.",
        },
        card7: {
          title: () => "Vouchery zwykłe i odroczone",
          youSave1: () => "radość klientów",
          youSave2: () => "regularnie powracający klienci",
          description: () =>
            "Twój Klient WRACA do Twojego lokalu, a Ty masz większy koszyk!",
        },
        card8: {
          title: () => "AI wbudowany w POS",
          youSave1: () => "czas",
          youSave2: () => "lepsze decyzje biznesowe",
          youSave3: () => "większy koszyk",
          description: () =>
            "Usprawnij procesy z pierwszym systemem dla gastronomii który ma wbudowane AI. Od automatycznego uzupełniania opisów produktów, przez inteligentne rekomendacje, aż po analizę sprzedaży - AI w naszym POS to Twój nowy, niezastąpiony asystent biznesowy.",
        },
        card9: {
          title: () => "Karty lojalnościowe wbudowane w system",
          youSave1: () => "lojalność klientów",
          youSave2: () => "większy koszyk",
          youSave3: () => "powracający klienci",
          description: () =>
            "Zbuduj lojalność klientów dzięki naszym wbudowanym kartom lojalnościowym NFC.",
        },
        card10: {
          title: () => "Aplikacja w przeglądarce",
          youSave1: () => "relacja z Klientem poza Twoim lokalem",
          youSave2: () => "większy koszyk",
          youSave3: () => "powracający klienci",
          description: () =>
            "Wiemy, że prawdziwa relacja z Klientem zaczyna się od momentu, w którym wychodzi on z Twojego lokalu. Dlatego oferujemy aplikację w przeglądarce, która pozwala Twoim Klientom na bycie w kontakcie z Twoją restauracją. Wysyłaj Klientem powiadomienia push prosto na telefon.",
        },
        card11: {
          title: () => "Ankiety broniące reputacji",
          youSave1: () => "lepsza pozycja w Google Maps",
          youSave2: () => "nowi klienci",
          youSave3: () => "zadowoleni klienci",
          description: () =>
            "Zbieraj opinie od swoich Klientów i reaguj na bieżąco bez poswięcania swojej reputacji.\nWewnętrzna ankieta pomoże Ci na rozwiązanie problemu w przypadku gorszej obsługi, a w przypadku zadowolenia Klienta - zachęci go do zostawienia pozytywnej opinii w publicznych serwisach.",
        },
        card12: {
          title: () => "Zarządzanie sprzętem",
          youSave1: () => "czas",
          youSave2: () => "spokój ducha",
          youSave3: () => "bezpieczeństwo danych",
          description: () =>
            "Przemyślany system zarządzania sprzętem z funkcją Rapid SafePOS to łatwość działania dla Twoich pracowników, a dla Ciebie - bezpieczeństwo i stabilność działania Twojego biznesu.\nProvisioning nowych urządzeń odbywa się płynnie i dynamicznie - wystarczy kilka kliknięć, aby dodać nowy terminal do Twojego systemu.",
        },
        card13: {
          title: () => "Serwer dedykowany",
          youSave1: () => "maksymalna stabilność",
          youSave2: () => "maksymalna szybkość działania",
          description: () =>
            "Rapidshop to system który już w podstawowej ofercie dostarcza wyjątkową stabilność i bezpieczeństwo danych. Jednak jeśli cenisz maksymalną stabilność i szybkość działania, skorzystaj z możliwości uruchomienia systemu Rapidshop na serwerze przeznaczonym tylko i wyłącznie dla Twojej firmy.",
        },
        card14: {
          title: () => "System ekranów kuchennych",
          youSave1: () => "czas",
          youSave2: () => "mniej pomyłek",
          youSave3: () => "brak straconego czasu",
          youSave4: () => "brak straconego jedzenia",
          description: () =>
            "Zoptymalizuj pracę swojej kuchni dzięki naszemu systemowi ekranów kuchennych",
        },
        card15: {
          title: () => "Ekrany Digital Signage",
          youSave1: () => "dynamiczna prezentacja menu",
          youSave2: () => "promocje w czasie rzeczywistym",
          youSave3: () => "profesjonalny wizerunek",
          description: () =>
            "Zintegrowane z Twoim systemem POS ekrany Digital Signage wyświetlają aktywne menu, promocje i produkty w czasie rzeczywistym. Przyciągnij uwagę Klientów dynamiczną prezentacją oferty, która automatycznie dostosowuje się do dostępności produktów i aktualnych promocji.",
        },
        card16: {
          title: () => "Ekrany zadań dla personelu",
          youSave1: () => "lepsze zarządzanie personelem",
          youSave2: () => "jasny podział obowiązków",
          youSave3: () => "zwiększona efektywność pracy",
          description: () =>
            "Dodawaj codzienne zadania dla Twojego zespołu i monitoruj ich realizację w czasie rzeczywistym. System ekranów zadań pozwala na przypisanie niezależnych zadań do członków personelu, śledzi postępy i pomaga utrzymać wysoki poziom organizacji w Twoim lokalu.",
        },
      },
    },
    pricing: {
      title: () => "Cennik",
      subtitle: () => "Wybierz plan dopasowany do potrzeb Twojej firmy",
      plans: {
        start: {
          title: () => "Start",
          price: () => "99 zł",
          priceDescription: () => "miesięcznie",
          feature1: () => "1 stanowisko POS",
          feature2: () => "Chmura Rapidshop",
          feature3: () => "Raporty sprzedaży",
          feature4: () => "Wsparcie techniczne",
          feature5: () => "Automatyczne aktualizacje",
          addition: () => "+ Konfiguruj elementy systemu według potrzeb",
          cta: () => "Rozpocznij",
        },
        enterprise: {
          title: () => "Enterprise",
          price: () => "Na zapytanie",
          priceDescription: () => "dla dużych sieci",
          feature1: () => "Serwer dedykowany",
          feature2: () => "Nieograniczona liczba stanowisk",
          feature3: () => "Rapidshop AI (chatbot w kiosku)",
          feature4: () => "Dedykowany opiekun klienta",
          feature5: () => "Pełna personalizacja systemu",
          feature6: () => "Dostęp do REST API dla wszystkich funkcji",
          feature7: () => "Szkolenia dla zespołu",
          feature8: () => "Własny skrypt promocji",
          cta: () => "Skontaktuj się",
        },
      },
    },
  },
  contactAppendix: {
    title: () => "Chcesz wiedzieć więcej?",
    description: () =>
      `Czy wiesz, że abonamenty za usługi Rapidshop kosztują już
            <b>od 3,19 zł netto</b> za dzień? Już w tej cenie dostajesz sporo!`,
    description2: () =>
      `Zachęcamy do <a href="/kontakt">pozostawienia kontaktu</a>, aby
            dowiedzieć się więcej i zamówić instalację rozwiązania Rapidshop w
            Twoim punkcie. Nasz doradca zaproponuje dogodny termin spotkania
            online, na którym przedstawi Ci, jak nowe technologie mogą realnie
            pomóc w zwiększeniu Twojego zysku.`,
    cta: () => `Skontaktuj się`,
  },
  infoPages: {
    contactForm: {
      title: () =>
        "Rozpocznij techniczną rewolucję i zacznij zwiększać swój zysk",
      description: () => `Porozmawiajmy!`,
      enum1: () =>
        `Pozostaw nam Twoje dane kontaktowe. Twój dedykowany doradca zaproponuje termin na krótkie spotkanie online, na którym pokażemy Ci, <strong>jak nowe technologie mogą zwiększyć zysk Twojej restauracji</strong>.`,
      enum2: () =>
        `Wolisz spotkać się z nami na
            żywo? Nasze biuro znajduje się dwa kroki
            od warszawskiego Dworca Centralnego. Umówimy spotkanie, na którym
            będziesz mógł własnoręcznie przetestować system Rapidshop.`,
      enum3: () =>
        `Wolisz wysłać maila? Napisz do nas: <a href="mailto:kontakt@rapidshop.pl">kontakt@rapidshop.pl</a>.`,
    },
    discountSystem: {
      subtitle: () =>
        "Angażuj, zaskakuj, zachęcaj do powrotów. Zwiększaj sprzedaż",
      title: () => "z systemem promocji i rabatów",
      hints: {
        hint1: () => "Drukowanie voucherów bezpośrednio pod paragonem",
        hint2: () => "Vouchery na ekranie Klienta",
        hint3: () => "Lojalizacja",
      },
      sectionTitle: () =>
        "System promocji i rabatów to nie tylko narzędzie do zwiększenia sprzedaży, ale także sposób na zbudowanie lojalności Klientów.",
      description: () =>
        `Dzięki naszemu systemowi promocji i rabatów możesz zaskakiwać
            Klientów atrakcyjnymi ofertami, które zwiększają ich zadowolenie i
            zachęcają do powrotów. Drukuj vouchery bezpośrednio pod paragonem,
            wyświetlaj promocje na ekranie Klienta, a także korzystaj z funkcji
            lojalizacji, by nagradzać Klientów za ich aktywność.`,
      comingSoon: () => `Już niebawem w Rapidshop!`,
      summary: () =>
        `Zrób więcej i obsłuż lepiej<br />
        dzięki magii sztucznej inteligencji AI w Twoim POS!`,
    },
    cloud: {
      subtitle: () => "Rapidshop Cloud to intuicyjny",
      title: () => "chmurowy system zarządzania sprzedażą",
      hints: {
        hint1: () => "Widoczność operacji",
        hint2: () => "Dostępna wszędzie tam, gdzie Internet",
        hint3: () => "Kontrola stanu urządzeń",
      },
      description: () =>
        `Zarządzanie biznesem jeszcze nigdy nie było tak proste i efektywne
            jak z Rapidshop Cloud. Dzięki naszemu systemowi POS, opartemu na
            chmurze, otrzymujesz natychmiastowy dostęp do wszelkich informacji
            dotyczących Twojego przedsiębiorstwa. <b>Zyskaj pełną kontrolę</b>
            nad każdym aspektem swojej działalności, od zarządzania produktami,
            przez monitorowanie transakcji, aż po zarządzanie zespołem i
            urządzeniami.`,
      subheader1: () => `Łatwe i potężne zarządzanie produktami`,
      subheader1Content: () =>
        `Rapidshop Cloud pozwala na intuicyjne zarządzanie bazą produktów,
            dodawanie atrybutów istotnych dla narzędzi AI, oraz tworzenie
            zarówno prostych, jak i złożonych produktów. <b>Produkty złożone</b>
            to kompozycje tworzone z produktów prostych, które mogą mieć stałą
            cenę lub cenę zależną od wybranej kompozycji. Produkty możesz
            organizować w prezentacje, co pozwala na tworzenie menu
            dostosowanego do różnych kanałów, takich jak POS, kioski, strona
            internetowa czy portale dostaw.`,
      subheader2: () => `Zwiększona widoczność transakcji`,
      subheader2Content: () =>
        `Dzięki Rapidshop Cloud, przedsiębiorca może śledzić listę transakcji
            oraz generować raporty dotyczące sprzedaży w czasie rzeczywistym.{" "}
            <b>Wszystkie transakcje są dostępne w jednym miejscu</b>,
            niezależnie od kanału, z którego pochodzą. To ogromne ułatwienie
            pozwala na bieżąco analizować wyniki finansowe i podejmować świadome
            decyzje biznesowe.`,
      subheader3: () => `Zarządzanie pracownikami`,
      subheader3Content: () =>
        `Nasze oprogramowanie umożliwia nadawanie uprawnień Twojemu
            zespołowi, przeglądanie podsumowań czasu pracy i przypisywanie
            transakcji do konkretnych pracowników. 
            <b>Możesz generować raporty dotyczące wydajności</b>
            pracowników, co pozwala na efektywne zarządzanie i motywowanie
            Twojego zespołu do jak najlepszej pracy.`,
      subheader4: () => `Zarządzanie urządzeniami`,
      subheader4Content: () =>
        `Rapidshop Cloud umożliwia zdalne zarządzanie urządzeniami, co
            pozwala na bieżąco monitorować ich stan. Możesz
            zdalnie aktualizować menu, a nawet blokować
            wybrane dania, niezależnie od typu urządzenia.
            <b>
              Wszystko po to, abyś mógł się skupić na tym, co naprawdę ma
              znaczenie.
            </b>
            Dzięki temu masz pełną kontrolę nad swoim
            przedsiębiorstwem, niezależnie od tego, gdzie się znajdujesz.`,
      subheader5: () => "Już niedługo",
      subheader5Content: () =>
        `Nowe narzędzia AI w naszym systemie pozwolą Ci na jeszcze bardziej
            efektywne zarządzanie biznesem. Dzięki sztucznej inteligencji, Twój
            system POS będzie w stanie analizować dane i proponować Ci
            optymalizacje, które pomogą Ci w
            <b>przyciąganiu Klientów i zwiększaniu obrotów</b>. Wiele
            codziennych zadań będzie wykonywanych automatycznie, co pozwoli Ci
            skupić się na najważniejszych aspektach prowadzenia biznesu.`,
    },
    devices: {
      title: () => "Urządzenia POS",
      subtitle: () => "Szybkie, lekkie i zwiększające sprzedaż",
      hints: {
        hint1: () => "System Android",
        hint2: () => "Proste i energooszczędne",
        hint3: () => "Zintegrowane z czytnikami i drukarkami",
      },
      title2: () => "Nowe sposoby na sprzedaż",
      description: () =>
        `Rynek urządzeń POS w ostatnich latach przeszedł ogromną rewolucję.
          Dziś sprzęt POS to nie tylko komputer zliczający kolejne linie
          zamówienia. Dzisiaj są to multimedialne kombajny, które nie tylko
          przyjmują zamówienie, ale są też narzędziem do budowania relacji z
          Klientem. <b>W Rapidshop wykorzystujemy moc i potencjał nowoczesnych urządzeń
              POS, aby napędzać Twoją sprzedaż.</b>`,
      devices: {
        hint1: () => "Czytniki NFC",
        hint2: () => "Karty Klienta",
        hint3: () => "Czytniki QR",
        hint4: () => "E-Paragony",
      },
      summary: () => `Zrób więcej i obsłuż lepiej<br />
        dzięki magii sztucznej inteligencji AI w Twoim POS!`,
    },
    kds: {
      subtitle: () => "Nowoczesna i zintegrowana",
      title: () => "Aplikacja KDS",
      hints: {
        hint1: () => "Pełna kontrola nad stanem zamówień",
        hint2: () => "Drukuj poszczególne pozycje",
      },
      description: () =>
        `<h2>
            Aplikacja KDS to centrum dowodzenia nad Twoją kuchnią. Dzięki niej
            Twoi kelnerzy doskonale wiedzą, co i kiedy przygotować.
          </h2>
          <p>
            Nasza aplikacja KDS to nie tylko wygoda, ale także sposób na
            zwiększenie sprzedaży i zadowolenia Klientów. Dzięki ergonomicznemu
            designowi i intuicyjnemu interfejsowi, Twoi kucharze na bieżąco
            aktualizują stan zamówień, co przekłada się na szybkość obsługi
            Klientów i wzrost obrotów.
          </p>
          <p>
            W naszej dotykowej aplikacji KDS Kelnerzy mogą na bieżąco drukować
            zamówienia na Twoją drukarkę KDS.{" "}
            <b>
              Zgubiony wydruk nie jest już więcej problemem, a Twoi Klienci
              zawsze dostają to, na co czekają.
            </b>
          </p>
          <p>
            Dobierz <b>Ekran Numerków</b> do swojego KDS. Twoi pracownicy z
            poziomu KDS mogą zmieniać stany zamówień na ekranie dla Twoich
            klientów, i ogłaszać możliwość odbioru dań, co jeszcze bardziej
            usprawnia cały proces na Kuchni i wydawce.
          </p>
          <p>
            Wkrótce w aplikacji KDS pojawią się także nowe funkcje{" "}
            <b>Rapidshop AI</b>, które jeszcze bardziej usprawnią procesy w
            Twojej kuchni.
          </p>`,
      summary: () =>
        `Zainwestuj w nowe technologie
            <br />i zwiększ sprzedaż, optymalizując pracę!`,
    },
    rapidshopAI: {
      subtitle: () => "Magia AI w Twojej restauracji",
      title: () => "Rapidshop AI",
      description1Title: () => `
        Zrób więcej, obsłuż lepiej. <br /> Magia sztucznej inteligencji w
            Twoim punkcie sprzedaży!
      `,
      description1: () =>
        `Zastosuj sztuczną inteligencję w swoim systemie POS, aby{" "}
                  <b>zwiększyć wydajność i jakość obsługi klienta</b>. Rapidshop AI to
                  innowacyjne rozwiązanie, które wykorzystuje najnowsze osiągnięcia w
                  dziedzinie sztucznej inteligencji, aby pomóc Twojej restauracji w
                  osiągnięciu lepszych wyników. Dzięki Rapidshop AI możesz
                  zautomatyzować wiele procesów, co pozwoli Ci zaoszczędzić czas i
                  pieniądze.`,
      features: {
        titles: {
          title: () => "Generowanie oraz tłumaczenie nazw i opisów produktów",
          description: () =>
            `Rapidshop AI potrafi generować oraz tłumaczyć nazwy i opisy produktów
                      w Twoim systemie POS. Dzięki temu możesz łatwo dostosować swoje menu
                      do potrzeb klientów z różnych krajów, co zwiększa ich satysfakcję i
                      lojalność, bez potrzeby angażowania dodatkowych pracowników.`,
        },
        aiAgents: {
          title: () => `Asystenci głosowi AI w kioskach samoobsługowych`,
          description:
            () => `Rapidshop AI to także agenci AI, którzy mogą być zainstalowani w
          kioskach samoobsługowych. Dzięki nim klienci mogą łatwo zamawiać
          jedzenie i napoje, a także uzyskiwać informacje o produktach i
          promocjach. Agenci AI są dostępni 24/7, a także nigdy się nie męczą,
          co oznacza, że klienci mogą korzystać z kiosków samoobsługowych o
          każdej porze dnia i nocy.`,
        },
      },
    },
    aiKiosk: {
      subtitle: () => "Poznaj nasze przełomowe",
      title: () => "Kioski samoobsługowe",
      hints: {
        hint1: () => "Ze sztuczną inteligencją",
        hint2: () => "Dobry design i dopracowane UI",
        hint3: () => "Dla wzrostu obrotów",
      },
      description1: () =>
        `Kioski samoobsługowe to absolutny hit obecnych czasów. Dla Ciebie
            jest to szansa na większe przychody!`,
      description2: () =>
        `To szansa na dotarcie do nowych Klientów i zaproponowanie im swoich
            produktów w chwilach, w których się nad tym zastanawiają.`,
      description3: () =>
        `To większe zamówienia, dzięki niezmiennie dobrym rekomendacjom,
            lepszej komunikacji Twoich rabatów i ofert.`,
      description4: () =>
        `Nasz elegancki kiosk to połączenie nowoczesnego designu,
                    funkcjonalności i prostoty, które idealnie wkomponuje się w każdą
                    przestrzeń sprzedażową. Możesz go umieścić na wyeksponowanym
                    postumencie lub dyskretnie wkomponować na blacie w Twoim lokalu.
                    Klienci cenią nasze kioski za komfort, który pozwala im w spokoju
                    zapoznać się z ofertą. Dzięki inteligentnym funkcjom sprzedaży i
                    intrygującym propozycjom widocznym na ekranie, zachęcają do
                    częstszego wyboru i zakupu większej ilości pozycji z menu.`,
      description5: () =>
        `Nasze kioski działają płynniej, szybciej i dostarczają Klientowi
            więcej możliwości.`,
      description6:
        () => `Posiadanie kiosku samo w sobie nie jest żadną sztuką. Kluczem do
            sukcesu jest to, jak ten kiosk funkcjonuje, jakie doświadczenia
            oferuje Twoim Klientom i jaką wygodę zapewnia. W dzisiejszych
            czasach, kiedy technologia jest wszechobecna, użytkownicy oczekują
            intuicyjnego i przyjaznego interfejsu. 
            <b>Kioski Rapidshop dostarczają taki interfejs.</b> Z łatwym w
            obsłudze systemem, klienci szybciej znajdują to, czego szukają, co
            zwiększa ich satysfakcję i skłania do powrotów. Natomiast 
            <b>możliwość proponowania Klientom dodaktów do zamówienia</b> 
            bezpośrednio w Kiosku może być łatwym sposobem na zwiększenie Twoich
            przychodów.`,
      description7: () => `
        Interfejs użytkownika jest jednak tylko częścią większej całości,
            jaką jest doświadczenie użytkownika (UX). To nie tylko to, jak coś
            wygląda, ale przede wszystkim to, jak działa. Dobra architektura
            informacji, płynna nawigacja i szybki czas reakcji to tylko niektóre
            aspekty, które wpływają na pozytywne doświadczenie Twojego Klienta.
      `,
      description8: () =>
        `Jeżeli ktoś ma pozytywne doświadczenia z korzystania z kiosku, o
                    wiele chętniej wróci do niego w przyszłości. 
                    <b>
                      Poczucie, że jesteśmy w stanie szybko i bezproblemowo załatwić to,
                      co chcemy, budzi pozytywne emocje
                    </b> 
                    - a to właśnie emocje są tym, co przyciąga nas do produktów i usług.
                    Stawiając na dobrą jakość UX, inwestujesz 
                    <b>
                      w przyszłość swojego biznesu oraz zadowolenie swoich Klientów.
                    </b>
      }`,
      aiSection: {
        title: () => `Znasz to z telefonu. Naciskasz, mówisz...
            <span style="fontSize: "1.3em">i jest!</span>
            <br />
            Pomyśl, że Twój kiosk może być tak samo inteligentny!`,
        description: () => `<strong>
                    Koniec z ograniczeniami. Pozwól Twoim Klientom rozmawiać z kioskiem
                    i zwiększaj sprzedaż!
                  </strong>
        
                  <p>
                    Kiosk z AI to nie tylko nowoczesne urządzenie, ale także nowe
                    możliwości dla Twojego biznesu. Dzięki sztucznej inteligencji{" "}
                    <b>
                      Twój kiosk może sam, proaktywnie podjąć interakcję z Twoim
                      Klientem.
                    </b>
                  </p>
                  <p>
                    Kiosk z AI to również sposób na dotarcie do wiekszej liczby Klientów
                    niż w standardowym Kiosku. Asystent głosowy oparty o najnowsze
                    modele językowe sztucznej inteligencji ogromnie ułatwia komunikację
                    z każdym Klientem - możesz otworzyć się na nowe grupy Klientów,
                    które wcześniej nie korzystały z Twoich kiosków.
                  </p>
        `,
      },
      languageBarrierSection: {
        title: () => `Pożegnaj barierę językową i wyróżnij się <br />
            wyjątkową obsługą turystów w Twoim lokalu!`,
        description: () =>
          `<p>
            Prowadzisz biznes w miejscu, gdzie często pojawiają się turyści? A
            może Twoi Klienci to osoby, które nie czują się pewnie w języku
            polskim? Kiosk z AI to idealne rozwiązanie, które pozwala na łatwą i
            intuicyjną komunikację z każdym Klientem. Dzięki asystentowi
            głosowemu, każdy Klient może w prosty sposób złożyć zamówienie,
            otrzymać informacje o produktach i skorzystać z promocji. To nie
            tylko ułatwia komunikację, ale także pozwala na zwiększenie
            sprzedaży i przyciągnięcie nowych Klientów.
          </p>
          <p>
            Nie musisz sam wprowadzać opisów produktów w różnych językach - nasz
            asystent głosowy oparty o AI
            <b>
              jest w stanie przetłumaczyć informacje na język Klienta w
              okamgnieniu
            </b>
            i zależnie od bieżącej potrzeby, co pozwala na sprawną i
            bezproblemową komunikację.
            <b>
              Dostarczasz Klientowi wysoki poziom obsługi, nawet jeśli Twoi
              pracownicy nie znaja języka Klienta
            </b>
            , co otwiera nowe możliwości dla Twojego biznesu.
          </p>`,
      },
      safeposSection: {
        title: () =>
          `Rapid SAFEPOS - przewidywalność i cyberbezpieczeństwo w Kiosku`,
        description: () => `
          <p>
            Dobry Kiosk to taki Kiosk, który zapewnia stabilność działania.
            <b>
              Każde z urządzeń samoobsługowych wymaga odpowiedniego zarządzania,
              aby mogło spełniać swoje funkcje w sposób bezpieczny i niezawodny
            </b>
            . Aby osiągnąć ten cel, proponujemy Państwu nasze rozwiązanie "Rapid
            SAFEPOS", które preinstalujemy na urządzeniach dostarczonych do
            Państwa. Dzięki niej każdy właściciel kiosku zyskuje pewność, że
            jego biznes <b>działa jak dobrze naoliwiona maszyna.</b>
          </p>
          <p>
            <a href="/latwe-zarzadzanie-sprzetem">
              Więcej informacji o rozwiązaniu Rapid SAFEPOS &gt;
            </a>
          </p>`,
      },
    },
    posApp: {
      subtitle: () => "Ergonomiczna, przyjazna i w pełni mobilna",
      title: () => "Aplikacja sprzedażowa",
      hints: {
        hint1: () => "Na urządzeniu na blacie",
        hint2: () => 'Na urządzeniu "do ręki"',
        hint3: () => "Centrum sterowania, niezależnie od miejsca",
      },
      descriptionTitle: () =>
        `Nasza aplikacja POS działa tak samo, czy to na blacie, czy w ręku
                      Twojego kasjera. Koniec z bieganiem do baru!`,
      description: () =>
        `<p>
              Teraz Twoja załoga może działać efektywnie, eliminując zbędne
              zamieszanie. Nasza nowoczesna aplikacja POS nie tylko ułatwia
              codzienne operacje, ale również stanowi klucz do zwiększenia
              sprzedaży i podniesienia poziomu zadowolenia Klientów.
            </p>
            <p>
              Wyjątkowy, ergonomiczny design i intuicyjny interfejs pozwalają
              Twoim pracownikom obsługiwać zamówienia w mgnieniu oka. To
              bezpośrednio przekłada się na pozytywne doświadczenia Klientów
              oraz znaczący wzrost obrotów.
            </p>
            <h2>
              Wykorzystaj ekran Klienta aby wzmocnić więź i budować lojalność
            </h2>
            <p>
              Ekran Klienta to znacznie więcej niż tylko podgląd rachunku.
              Uzupełnij działania swojej załogi, wyświetlając spersonalizowane
              oferty, promocje oraz informacje o produktach. Zainspiruj
              dodatkowe zakupy, stwórz powody do powrotu i zaskocz swoich
              Klientów unikalnym doświadczeniem.
            </p>
            <h2>Fiskalizacja i płatności</h2>
            <p>
              Fiskalizacji rachunków otwartych w aplikacji sprzedażow dokonasz
              bez problemu na drukarce fiskalnej (aktualnie obsługujemy drukarki
              POSNET), a rozwiązania płatnicze i obsługę kart dostarcza firma{" "}
              <b>eservice</b>. Dostawcy urządzeń fiskalnych i płatniczych, z
              którymi współpracujemy to <b>liderzy na rynku</b>, co gwarantuje
              stabilność i niezawodność.
            </p>`,
      summary: () => `Zrób więcej i obsłuż lepiej
              <br />
              dzięki magii sztucznej inteligencji w Twoim POS!`,
    },
    safePOS: {
      subtitle: () => "Rapid SAFE POS to aplikacja, która w końcu pozwoli na",
      title: () => "Łatwe zarządzanie sprzętem",
      hints: {
        hint1: () => "Mniej nieprzewidzianych awarii",
        hint2: () => "Większe bezpieczeństwo",
        hint3: () => "Kontrola stanu urządzeń",
      },
      description: () => `
      <p>
          Zarządzanie sprzętem może być wyzwaniem, ale "Rapid SAFE POS" to
          aplikacja, która upraszcza wszystko w mgnieniu oka.{" "}
          <b>
            To jak magiczna różdżka, która zamienia trudne w łatwe, a
            skomplikowane w proste.
          </b>
          Dzięki niej właściciel punktu sprzedaży lub placówki gastronomicznej
          nie muszą martwić się o techniczne zawiłości ani obawiać awarii. Z
          "Rapid SAFE POS" zyskujesz pełną kontrolę nad swoimi urządzeniami i
          możesz skupić się na tym, co naprawdę się liczy - zadowoleniu Klientów
          i rozwijaniu biznesu.
        </p>
        <p>
          Jednym z kluczowych atutów aplikacji "Rapid SAFEPOS" jest to, że
          <b>
            dzięki niej Twoi pracownicy i Klienci mają dostęp tylko do aplikacji
            związanych z ich pracą.
          </b>{" "}
          Oznacza to, że pracownicy nie mają możliwości przypadkowego zmienienia
          ustawień lub wprowadzenia modyfikacji, które mogłyby zaszkodzić
          urządzeniu. Dzięki temu
          <strong>
            zmniejszamy liczbę potencjalnych sytuacji gdzie musisz skontaktować
            się z serwisem.
          </strong>
        </p>
        <p>
          Dzięki aplikacji "Rapid SAFEPOS", masz lepszą kontrolę nad tym, jak
          działają Twoje urządzenia. Aplikacja umożliwia{" "}
          <b>śledzenie stanu urządzenia w czasie rzeczywistym</b>, niezależnie
          od rodzaju i modelu, co pozwala na szybszą reakcję
          w razie ewentualnych problemów. Ponadto, aktualizacje aplikacji
          sprzedażowej
          <b>
            nie wymagają wielu skomplikowanych kroków - wykonywane są jednym
            kliknięciem
          </b>
          . Jeżeli zajdzie potrzeba dodania funkcji do Twojego kiosku - odbywa
          się to błyskawicznie. To nie tylko zwiększa bezpieczeństwo całego
          systemu, ale także umożliwia lepsze zarządzanie sprzedażą, co w
          skuteczny sposób wpływa na ogólną wydajność biznesu.
        </p>
        <p>
          Korzyści płynące z aplikacji "Rapid SAFEPOS" przekładają się również
          na
          <b>redukcję kosztów związanych ze szkoleniem pracowników</b>. Dzięki
          uproszczonemu interfejsowi i ograniczonemu zakresowi możliwych
          działań, nauka obsługi urządzeń staje się znacznie łatwiejsza i mniej
          czasochłonna. W rezultacie pracodawca może zaoszczędzić zarówno czas,
          jak i środki finansowe, możesz przeznaczyć na inne ważne aspekty
          rozwijania swojego biznesu. Dzięki tym wszystkim elementom, kioski
          wyposażone w "Rapid SAFEPOS" stają się bardziej niezawodne, co pozwala
          utrzymać stabilność operacyjną i skoncentrować się na rozwoju firmy.
        </p>`,
    },
    pricing: {
      subtitle: () => "Wybór systemu Rapidshop to inwestycja w przyszłość",
      title: () => "zyskujesz nowoczesne technologie sprzedażowe",
      benefits: {
        incomes: () => `
            <h2>Wzrost zysków</h2>
            <p>
              Oszczędzaj czas i pieniądze. Nasz system pomoże Ci zmniejszyć
              zbędne koszty dzięki optymalizacji zarządzania zapasami oraz
              minimalizacji błędów ludzkich podczas obsługi zamówień i
              płatności.
            </p>`,
        simplicity: () => `
            <h2>Prosty w użytkowaniu, łatwy do pokochania</h2>
            <p>
              Dzięki intuicyjnemu interfejsowi Twój personel stanie się
              ekspertem w mgnieniu oka. Szkolenie zajmuje minuty, a nie godziny,
              co pozwala Ci skupić się na doskonałej obsłudze Klientów.
            </p>`,
        realtime: () => `
            <h2>Dane w czasie rzeczywistym na wyciągnięcie ręki</h2>
            <p>
              Podejmuj świadome decyzje dzięki natychmiastowemu dostępowi do
              raportów sprzedaży, preferencji Klientów i wyników pracy zespołu.
              Prześcignij konkurencję wiedząc co działa najlepiej dla Twojego
              biznesu.
            </p>`,
        lessBreakdowns: () => `
            <h2>Mniej przestojów, większy spokój ducha dla Ciebie</h2>
            <p>
              Nasz system POS charakteryzuje się niższymi kosztami utrzymania
              dzięki nowoczesnym i przystępnym cenowo urządzeniom. Wszystko jest
              zaprojektowane z myślą o trwałości i niezawodności, co oznacza
              mniej przestojów i większą satysfakcję z pracy Twojego zespołu.
            </p>`,
      },
      suitableForYou: () => `
      <h1>W końcu - dopasowany do Ciebie</h1>
        <p>
          Nasze elastyczne plany cenowe są stworzone z myślą o firmach każdej
          wielkości. Pomóż usprawnić operacje i wynieś swoją restaurację na
          wyższy poziom.
          <br />
          <strong>
            Zostaw nam swój kontakt, zaplanujemy rozmowę, na której wybierzemy
            idealny wariant wdrożenia!
          </strong>
        </p>`,
      minimalPlan: () => `
        netto za m-c - od takiej kwoty zaczynają się nasze plany
            subskrypcji. Już w takim pakiecie dostajesz sporo!
            <div>Napisz i dowiedz się więcej.</div>`,
    },
  },
  contactForm: {
    cta: () => "KLIKNIJ i zostaw kontakt",
    orderNow: () => "Zamów teraz",
  },
};

export default locale;
